module.exports = __webpack_public_path__ + "static/media/Follower_Button-12.4a077394.png";